<div class="icon-text-container">
  <div class="icon">
    <img alt="" height="24" ngSrc="assets/images/icon-comment.svg" width="24">
  </div>
  <div class="text">
    <form [formGroup]="form" (ngSubmit)="send()">
      <label for="textarea" class="headline semiBold" [class.form-validated]="textareaValueLength > 0">
        {{ 'APPOI.FEEDBACK_FORM.COMMENT_OPTIONAL' | translate }}
      </label>
      <mat-form-field *ngIf="!messageSent"
                      hintLabel="{{ 'APPOI.FEEDBACK_FORM.COMMENT_OPTIONAL_HINT' | translate }}"
                      [class.form-validated]="textareaValueLength > 0">
        <textarea id="textarea" formControlName="textarea" matInput maxlength="150" rows="4"></textarea>
        <mat-hint id="textarea-length-hint" align="end" [class.form-validated]="textareaValueLength > 0">
          {{ textareaValueLength }}/150
        </mat-hint>
      </mat-form-field>
      <div *ngIf="messageSent">
        <div class="sent-message">{{ submittedMessage }}</div>
      </div>
      <div *ngIf="!messageSent" class="actions">
        <button type="submit"
                [disabled]="textareaValueLength <= 0"
                [gtmEventData]="{ 'flowType': 'PROPOSAL_ACCEPTED' }"
                [gtmEventName]="'add_note'"
                class="vi-button vi-button-xs"
                mat-flat-button>{{ 'APPOI.BUTTON.SEND_MESSAGE' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
